// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1oMKR","right":"styles_right__10prV"};